<template>
  <div :class="menuClass + ' custom-container'">
    <div class="profil page-wrapp">
      <v-row class="justify-center" :style="!$vuetify.breakpoint.smAndDown">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 6 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'justify-content-center'
              : 'pt-0 mt-0'
          "
        >
          <div class="label">Profil</div>
          <v-row class="mt-0 pt-0">
            <v-col>
              <v-row
                class="profil-link"
                v-for="(item, index) in links"
                v-bind:key="index"
                v-on:click="goToLink(item.to)"
              >
                <v-col cols="1">
                  <v-icon color="primary" size="30">{{ item.icon }}</v-icon>
                </v-col>
                <v-col cols="10" class="text-left ml-2">
                  <v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{ item.text }}</v-card-title
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import "./Profil.scss";

export default {
  name: "Profil",

  components: {},

  data() {
    return {
      menuClass: "",
      links: [
        {
          text: "Personlig informasjon",
          icon: "mdi-account-outline",
          to: "#/profil/personal",
        },
        {
          text: "Kontaktinformasjon",
          icon: "mdi-bell-outline",
          to: "#/profil/contact",
        },
        {
          text: "Mine avtaler",
          icon: "mdi-gauge-full",
          to: "#/profil/contract",
        },
        {
          text: "Endre passord",
          icon: "mdi-lock-outline",
          to: "#/profil/password",
        },
      ],
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {
    goToLink(route) {
      let tmp = document.createElement("a");
      tmp.href = route;
      tmp.click();
    },
  },
};
</script>
